export enum OnboardingModalSlidePlatform {
	IOS = 'IOS',
	ANDROID = 'ANDROID',
}

export interface OnboardingModal {
	i18nBaseKey: string;
	imageBaseName: string;

	// Not gonna use it for now
	// expectedSlidesCount: number;
	// slidesPlatforms?: Record<number, OnboardingModalSlidePlatform>;
}
